import { Preferito } from './preferito';

export class ElencoPreferiti {
  elenco: Array<Preferito>;
  page: number;
  size: number;
  maximumPages: number;
  pageSize: number;
  totalElements: number;
}
